// 메인 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역
import animationHelper from 'src/com/keymansco/chihuahuaone/helper/animationHelper';
import businessHelper from 'src/com/keymansco/chihuahuaone/helper/businessHelper';
import constHelper from 'src/com/keymansco/chihuahuaone/helper/constHelper';
import deviceHelper from 'src/com/keymansco/chihuahuaone/helper/deviceHelper';
import elementHelper from 'src/com/keymansco/chihuahuaone/helper/elementHelper';
import localizationHelper from 'src/com/keymansco/chihuahuaone/helper/localizationHelper';
import logHelper from 'src/com/keymansco/chihuahuaone/helper/logHelper';
import modelHelper from 'src/com/keymansco/chihuahuaone/helper/modelHelper';
// import nativeBaseDefaultTheme from 'src/com/keymansco/chihuahuaone/helper/nativeBaseDefaultTheme';
import nativeBaseUtilityProps from 'src/com/keymansco/chihuahuaone/helper/nativeBaseUtilityProps';
import navigationHelper from 'src/com/keymansco/chihuahuaone/helper/navigationHelper';
import objectHelper from 'src/com/keymansco/chihuahuaone/helper/objectHelper';
import storageHelper from 'src/com/keymansco/chihuahuaone/helper/storageHelper';
import stringHelper from 'src/com/keymansco/chihuahuaone/helper/stringHelper';
import styleHelper from 'src/com/keymansco/chihuahuaone/helper/styleHelper';
import themeHelper from 'src/com/keymansco/chihuahuaone/helper/themeHelper';
import timerHelper from 'src/com/keymansco/chihuahuaone/helper/timerHelper';
import uxHelper from 'src/com/keymansco/chihuahuaone/helper/uxHelper';

// 동적 영역

// =================================================================================================
// 상수
// =================================================================================================

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  animation: animationHelper,
  business: businessHelper,
  const: constHelper,
  device: deviceHelper,
  element: elementHelper,
  localization: localizationHelper,
  log: logHelper,
  model: modelHelper,
  // nativeBaseDefaultTheme: nativeBaseDefaultTheme,
  nativeBaseUtilityProps: nativeBaseUtilityProps,
  navigation: navigationHelper,
  object: objectHelper,
  storage: storageHelper,
  string: stringHelper,
  style: styleHelper,
  theme: themeHelper,
  timer: timerHelper,
  ux: uxHelper,
};
